import { reactive } from 'vue'

// 保存二级菜单当前选择的key
const store = reactive({
  defaultActive: '0',
})

export default {
  store,
}

// 模特市场
export const modelMarketGuideList = [
  {
    key: 'template1',
    nextKey: 'template2',
    url: require('@/assets/images/newGuide/modelMarket1.png'),
    next: require('@/assets/images/newGuide/modelMarket2.png'),
  },
  {
    key: 'template2',
    nextKey: 'template3',
    url: require('@/assets/images/newGuide/modelMarket2.png'),
    next: require('@/assets/images/newGuide/modelMarket3.png'),
  },
  {
    key: 'template3',
    nextKey: 'template4',
    url: require('@/assets/images/newGuide/modelMarket3.png'),
    next: require('@/assets/images/newGuide/modelMarket4.png'),
  },
  {
    key: 'templat4',
    nextKey: 'template1',
    url: require('@/assets/images/newGuide/modelMarket4.png'),
    next: false,
  },
]
// 声音市场
export const ttsMarketGuideList = [
  {
    key: 'template1',
    nextKey: 'template2',
    url: require('@/assets/images/newGuide/ttsMarket1.png'),
    next: require('@/assets/images/newGuide/ttsMarket2.png'),
  },
  {
    key: 'template2',
    nextKey: 'template3',
    url: require('@/assets/images/newGuide/ttsMarket2.png'),
    next: require('@/assets/images/newGuide/ttsMarket3.png'),
  },
  {
    key: 'template3',
    nextKey: 'template4',
    url: require('@/assets/images/newGuide/ttsMarket3.png'),
    next: require('@/assets/images/newGuide/ttsMarket4.png'),
  },
  {
    key: 'templat4',
    nextKey: 'template1',
    url: require('@/assets/images/newGuide/ttsMarket4.png'),
    next: false,
  },
]
// 工作台
export const workBenchGuideList = [
  {
    key: 'template1',
    nextKey: 'template2',
    url: require('@/assets/images/newGuide/workBench1.png'),
    next: require('@/assets/images/newGuide/workBench2.png'),
  },
  {
    key: 'template2',
    nextKey: 'template3',
    url: require('@/assets/images/newGuide/workBench2.png'),
    next: require('@/assets/images/newGuide/workBench3.png'),
  },
  {
    key: 'template3',
    nextKey: 'template4',
    url: require('@/assets/images/newGuide/workBench3.png'),
    next: require('@/assets/images/newGuide/workBench4.png'),
  },
  {
    key: 'templat4',
    nextKey: 'template1',
    url: require('@/assets/images/newGuide/workBench4.png'),
    next: false,
  },
]
